import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuLinks = [
    { name: "Reiki Wellness", href: "#reiki", icon: "Activity" },
    { name: "DKL Merch", href: "#merch", icon: "ShoppingBag" },
    { name: "Meet the Founder", href: "#founder", icon: "User" },
    { name: "DKT Tokenomics", href: "#tokenomics", icon: "Zap" },
    { name: "Staking", href: "#staking", icon: "Lock" }
  ];

  return (
    <motion.nav 
      initial={{ y: -100 }} 
      animate={{ y: 0 }} 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'py-3' : 'py-6'}`}
    >
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
        <motion.div 
          whileHover={{ scale: 1.02 }} 
          className="relative group cursor-pointer" 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <div className="absolute inset-0 bg-black/40 backdrop-blur-md rounded-2xl border border-white/5 group-hover:bg-black/60 transition-all duration-300" />
          <div className="relative px-3 py-2 flex items-center gap-3">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/86073368fa597368b31df5a13528b417.png" 
              alt="Dai Kho Limited Logo" 
              className="h-10 md:h-12 w-auto object-contain drop-shadow-[0_0_10px_rgba(168,85,247,0.4)] invert" 
            />
            <span className="hidden sm:block font-black text-lg tracking-tighter text-white uppercase">Dai Kho Limited</span>
          </div>
        </motion.div>

        <div className="hidden lg:flex items-center gap-8 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
          <a href="#reiki" className="hover:text-emerald-400 transition-colors">Reiki</a>
          <a href="#merch" className="hover:text-pink-400 transition-colors">Merch</a>
          <a href="#tokenomics" className="hover:text-purple-400 transition-colors">Tokens</a>
          
          <div className="relative group">
            <button 
              onMouseEnter={() => setIsMenuOpen(true)} 
              className="flex items-center gap-2 text-white hover:text-purple-400 transition-colors py-2"
            >
              Discover <SafeIcon name="ChevronDown" className={`w-3 h-3 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
            </button>
            <AnimatePresence>
              {isMenuOpen && (
                <motion.div 
                  initial={{ opacity: 0, y: 10 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  exit={{ opacity: 0, y: 10 }} 
                  onMouseLeave={() => setIsMenuOpen(false)}
                  className="absolute top-full right-0 mt-2 w-64 glass-panel rounded-2xl p-4 border-white/10 shadow-2xl"
                >
                  <div className="space-y-2">
                    {menuLinks.map((link, i) => (
                      <a 
                        key={i} 
                        href={link.href} 
                        className="flex items-center gap-4 p-3 rounded-xl hover:bg-white/5 transition-all group/item"
                      >
                        <div className="w-8 h-8 rounded-lg bg-purple-500/10 flex items-center justify-center group-hover/item:bg-purple-500/20 transition-colors">
                          <SafeIcon name={link.icon} className="w-4 h-4 text-purple-400" />
                        </div>
                        <span className="text-xs text-slate-300 font-bold uppercase tracking-widest">{link.name}</span>
                      </a>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>

        <a 
          href="https://app.acuityscheduling.com/schedule.php?owner=39722108" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="relative group overflow-hidden px-8 py-3 rounded-xl bg-white text-black font-bold text-xs uppercase tracking-widest transition-all hover:scale-105 active:scale-95"
        >
          <span className="relative z-10">Book Session</span>
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-cyan-500 opacity-0 group-hover:opacity-20 transition-opacity" />
        </a>
      </div>
    </motion.nav>
  );
};

export default Navbar;